import React, { Component } from "react";
import LoaderPage from "./LoaderPage";
import JitsiMeet from "./JitsiMeet";
import { FetchRunningMeet, ActivateMeet } from "./../Meet/meet_actions";
import Auth from "../../services/authService";
import GuestUser from "./GuestUser";
import SimpleReactValidator from "simple-react-validator";
import { LoginWithTokenFxn } from "../../actions";
import { firebaseLogin } from "../../firebase/firebaseActions";

class MeetSelector extends Component {
    constructor(props) {
        super(props);
        this.state = {
            __meetings: [],
            __mounted: false,
            __isAuthenticatedUser: false,
            __uniqueKey: "",
            __join: false,
            __status: "",
            __isHost: false,
            isAuthenticatedRoom: true,
            sessionExpired: false,
            iAmRecorder: false,
            __GuestAlreadyExists: false,
        };
        this.validator = new SimpleReactValidator();
    }

    componentDidMount = async () => {
        if (location.href.includes("token=")) {
            const newUrl = new URL(location.href);
            const token = newUrl.searchParams.get("token");
            let response = await APP.store.dispatch(
                LoginWithTokenFxn({ token })
            );

            console.log("responseCCC", response);
            if (response?.ResponseCode === "1") {
                this.setState(
                    {
                        __isAuthenticatedUser: Auth.isAuthenticated(),
                        __isHost: response.isHost,
                    },
                    () => {
                        let email = Auth.getUserDetail()?.email;
                        let password = Auth.getUserDetail()?.firebase_password;
                        firebaseLogin({ email, password });
                        this.__Mounting();
                    }
                );
            } else if (response?.ResponseCode === "0") {
                this.setState(
                    {
                        sessionExpired: true,
                    },
                    () => {
                        setTimeout(() => {
                            window.close();
                            window.location.href = `https://${process.env.REACT_APP_WEBSITE_DOMAIN}`;
                        }, 5000);
                    }
                );
            }
        } else {
            this.setState(
                {
                    __isAuthenticatedUser: Auth.isAuthenticated(),
                    __isHost: false,
                },
                () => {
                    this.__Mounting();
                }
            );
        }
    };

    __Mounting = () => {
        const { __isAuthenticatedUser } = this.state;
        if (location.href.includes("config.iAmRecorder")) {
            const iAmRecorder =
                location.hash.split("config.iAmRecorder=")[1]?.split("&")[0] ??
                false;
            if (iAmRecorder) {
                this.setState({
                    iAmRecorder: true,
                });
            }
        } else if (__isAuthenticatedUser) {
            this.CheckMeet();
        } else {
            this.setState({ __mounted: true });
        }
    };

    CheckMeet = async () => {
        const { __isHost } = this.state;
        let room_name = location.pathname.replace(/[#\/]/g, "").toLowerCase();
        let { phone } = Auth.getUserDetail();
        if (room_name.includes(phone && phone.replace("+", ""))) {
            this.setState({ __join: true, __mounted: true });
        } else {
            const newUrl = new URL(location.href);
            const uniquekey = location.href.includes("uniquekey=")
                ? newUrl.searchParams.get("uniquekey")
                : "";
            const response = await APP.store.dispatch(
                FetchRunningMeet({ uniquekey, room_name })
            );
            if (response.code) {
                this.setState(
                    {
                        __mounted: true,
                        __meetings:
                            __isHost || response.response.length === 1
                                ? response.response
                                : response.response.filter(
                                      (value) => value.status === "Active"
                                  ),
                    },
                    () => {
                        const { __meetings } = this.state;
                        if (__meetings.length === 0) {
                            this.setState(
                                {
                                    isAuthenticatedRoom: false,
                                },
                                () => {
                                    setTimeout(() => {
                                        window.close();
                                    }, 2000);
                                }
                            );
                        }
                        if (__isHost && __meetings.length === 1) {
                            APP.store.dispatch(
                                ActivateMeet({
                                    uniquekey: __meetings[0].uniquekey,
                                })
                            );
                        }
                    }
                );
            }
        }
    };

    JoinMeet = () => {
        if (!this.validator.allValid()) {
            this.validator.showMessages();
            this.forceUpdate();
            return null;
        }
        const { __status, __uniqueKey } = this.state;
        if (__status === "NA" || __status === "Active") {
            APP.store.dispatch(ActivateMeet({ uniquekey: __uniqueKey }));
        }
        this.setState({ __join: true });
    };

    __GuestAlreadyExistsHandler = () => {
        this.setState({
            __GuestAlreadyExists: true,
        });
    };

    render() {
        const {
            __meetings,
            __mounted,
            __isAuthenticatedUser,
            __uniqueKey,
            __join,
            __status,
            isAuthenticatedRoom,
            sessionExpired,
            iAmRecorder,
            __GuestAlreadyExists,
        } = this.state;

        console.log("meet selector", this.state);
        console.log("__mounted", __mounted);
        console.log("__meetings", __meetings);
        console.log("iAmRecorder", iAmRecorder);
        console.log("isAuthenticatedRoom", isAuthenticatedRoom);
        console.log("isAuthenticatedRoom", isAuthenticatedRoom);

        if (sessionExpired && !iAmRecorder) {
            return <LoaderPage type="session-expired" />;
        }
        // if (!__mounted && !iAmRecorder) {
        //     return <LoaderPage />;
        // }

        if (!isAuthenticatedRoom && !iAmRecorder) {
            return <LoaderPage type="not-found" />;
        }
        return (
            <>
                {/* VIDEO CONFERENCE SCREEN */}
                {((__mounted && __meetings.length === 1) || iAmRecorder) && (
                    <JitsiMeet
                        uniquekey={__meetings[0]?.uniquekey ?? ""}
                        __status={__meetings[0]?.status ?? ""}
                        meetingDetails={__meetings && __meetings[0]}
                        iAmRecorder={iAmRecorder}
                        __GuestAlreadyExists={__GuestAlreadyExists}
                    />
                )}

                {/* GUEST USER SCREEN */}
                {__mounted && !__isAuthenticatedUser && !iAmRecorder && (
                    <GuestUser
                        __Mounting={() => {
                            this.setState(
                                { __isAuthenticatedUser: true },
                                () => {
                                    this.__Mounting();
                                }
                            );
                        }}
                        __GuestAlreadyExistsHandler={
                            this.__GuestAlreadyExistsHandler
                        }
                    />
                )}

                {/* MEETING LIST POPUP IF MORE THAN ONE MEETING AT A TIME */}
                {__mounted &&
                    !__join &&
                    __meetings.length > 1 &&
                    !iAmRecorder &&
                    __meetings[0]?.created_by_email ===
                        Auth.getUserDetail()?.email &&
                    this.MeetingListPopup(__meetings, __uniqueKey)}

                {/* DIRECTLY JOIN MEETING THROUGH LINK OR ROOM ID */}
                {__mounted && __join && !iAmRecorder && (
                    <JitsiMeet
                        uniquekey={__uniqueKey}
                        __status={__status}
                        meetingDetails={__meetings && __meetings[0]}
                    />
                )}
            </>
        );
    }

    MeetingListPopup = (__meetings, __uniqueKey) => {
        return (
            <div className="meeting-section-div">
                <div className="meeting-select-radio-div">
                    <div className="meeting-select-radio-listing">
                        <div className="row mb-3">
                            {__meetings.map((value, key) => {
                                return (
                                    <div
                                        className="col-md-6 multiselect-meet"
                                        key={`changes${key}`}
                                    >
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="__uniqueKey"
                                                id="inlineRadio1"
                                                value={value.uniquekey}
                                                onChange={(e) =>
                                                    this.setState({
                                                        __uniqueKey:
                                                            value.uniquekey,
                                                        __status: value.status,
                                                    })
                                                }
                                                checked={
                                                    __uniqueKey ===
                                                    value.uniquekey
                                                }
                                            />
                                            <label
                                                className="form-check-label"
                                                for="inlineRadio1"
                                            >
                                                {value.topic}
                                                {value.status === "Active" && (
                                                    <>
                                                        &nbsp;&nbsp;
                                                        <span
                                                            className="badge badge-success"
                                                            onClick={() =>
                                                                this.setState({
                                                                    __uniqueKey:
                                                                        value.uniquekey,
                                                                })
                                                            }
                                                        >
                                                            Join Previous
                                                        </span>
                                                    </>
                                                )}
                                            </label>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        {this.validator.message(
                            "Room",
                            __uniqueKey,
                            "required"
                        )}
                    </div>
                    <div className="meeting-select-submit">
                        <a
                            href={void 0}
                            className="submit-meeting"
                            onClick={this.JoinMeet}
                        >
                            Submit
                        </a>
                    </div>
                </div>
            </div>
        );
    };
}

export default MeetSelector;
